import axiosInstance from "../Api/AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_SERVICE_URL;

export const getLastRefreshDate = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}/GetLastRefreshDate`);
  return typeof response.data === "string" ? JSON.parse(response.data) : response.data;
};